import { useSubSessionUrlSync } from './useSubSessionUrlSync';

const SubSessionUrlSync = (): null => {
  useSubSessionUrlSync();
  return null;
};

export default SubSessionUrlSync;
